module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAD1BMVEX////VM0bOESbniJP////+7S8OAAAAAnRSTlPU+CChtw0AAAAxSURBVEjH7dWxDQAwCMAwqPoA/z/bG0B0c3bPyYput09OIAiCIMj+XywJQRAE+UEGPWWqAM74SM60AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/id.png
// module id = XP8I
// module chunks = 0